"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var planimetry_1 = require("./planimetry");
var MouseEventHandler_1 = require("./handler/MouseEventHandler");
var Engine_1 = require("./Engine");
var utils_1 = require("./utils");
/**
 * 视窗类
 */
var ViewPort = /** @class */ (function () {
    function ViewPort(options) {
        var _this = this;
        this.mouseEventHandler = new MouseEventHandler_1.MouseEventHandler(this);
        this.viewports = [];
        this.appendViewPort = function (viewport) {
            _this.viewports.push(viewport);
        };
        this.removeAllViewPort = function () {
            _this.viewports = [];
        };
        this.ctx = options.ctx;
        this.width = options.width;
        this.height = options.height;
        this.transformMatrix = options.transformMatrix;
        this.ctx.canvas.width = this.width;
        this.ctx.canvas.height = this.height;
        var _a = __read(this.transformMatrix, 6), a = _a[0], c = _a[1], e = _a[2], b = _a[3], d = _a[4], f = _a[5];
        this.ctx.setTransform(a, b, c, d, e, f);
        this.engine = new Engine_1.Engine(this.ctx, this);
        // this.mouseEventHandler.bind();  // 绑定事件
    }
    Object.defineProperty(ViewPort.prototype, "shapePoolSize", {
        get: function () {
            return this.engine.shapePoolSize;
        },
        enumerable: true,
        configurable: true
    });
    ViewPort.prototype.getShape = function (zindex) {
        return this.engine.getShape(zindex);
    };
    ViewPort.prototype.add = function (shape) {
        return this.engine.add(shape);
    };
    ViewPort.prototype.addSome = function (shapes) {
        return this.engine.addSome(shapes);
    };
    ViewPort.prototype.remove = function (shape) {
        return this.engine.remove(shape);
    };
    ViewPort.prototype.removeSome = function (shapes) {
        return this.engine.removeSome(shapes);
    };
    ViewPort.prototype.render = function (isClear) {
        return this.engine.render(isClear);
    };
    ViewPort.prototype.clearAll = function () {
        return this.engine.clearAll();
    };
    ViewPort.prototype.hitTest = function (p) {
        return this.engine.hitTest(p);
    };
    ViewPort.prototype.removeSelected = function () {
        return this.removeSelected();
    };
    /**
     * 触发一个鼠标事件
     * @param p 点
     * @param action 时间名称
     */
    ViewPort.prototype.trigger = function (p, action) {
        var vev = this.transformEvent(action, p);
        this.engine.trigger(vev);
    };
    /**
     * 克隆一个空白的viewport,此viewport的ctx是新的，其宽度与高度和当前侧viewport一致，且transformMatrix对象共享。
     */
    ViewPort.prototype.clone = function () {
        return new ViewPort({
            width: this.width,
            height: this.height,
            transformMatrix: this.transformMatrix,
            ctx: utils_1.createCanvasContext2d()
        });
    };
    ViewPort.prototype.cloneAndCopyAShape = function (shape) {
        var nv = this.clone();
        nv.engine.add(shape);
        return nv;
    };
    ViewPort.prototype.cloneAndCopyAShapeByIndex = function (index) {
        var shape = this.engine.getShape(index);
        return this.cloneAndCopyAShape(shape);
    };
    /**
     * 将物理点转换为抽象点
     * @param ev 事件名
     * @param p (0,0) 至 (width,height) 的点
     */
    ViewPort.prototype.transformEvent = function (ev, p) {
        var np = planimetry_1.transform(this.transformMatrix, p);
        return {
            p: np,
            action: ev,
            viewport: this,
        };
    };
    return ViewPort;
}());
exports.ViewPort = ViewPort;
//# sourceMappingURL=viewport.js.map